import { lazy, Suspense } from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import Today from './routes/Today.jsx';
import Yesterday from './routes/Yesterday.jsx';
import Archive from './routes/Archive.jsx';
import About from './routes/About.jsx';
import Ai from './routes/Ai.jsx';
import Privacy from './routes/Privacy.jsx';
import Terms from './routes/Terms.jsx';
import Admin from './routes/Admin.jsx';
import Guides from './routes/Guides.jsx';
import Guide from './routes/Guide.jsx';
import Stay from './routes/Stay.jsx';
import StayIndex from './routes/StayIndex.jsx';
import StayGuide from './routes/StayGuide.jsx';
import StayConfirmed from './routes/StayConfirmed.jsx';
import NotFoundPage from './components/NotFound.jsx';
import HarborChart from './components/HarborChart.jsx';
import { getSite } from './lib/brand.js';

// Two-brand split: this one deploy serves both domains. stay.vacations (host
// platform) renders StayApp; <city>.vacations renders the guest brief below.
// Lazy so the platform bundle never weighs down the guest site's LCP.
const StayApp = lazy(() => import('./stay/StayApp.jsx'));
// Per-listing revenue dashboard — operator-only, heavy, lazy for the same reason.
const RevenueAdmin = lazy(() => import('./routes/RevenueAdmin.jsx'));

export default function App() {
  if (getSite().brand === 'stay') {
    return (
      <Suspense fallback={<div className="min-h-screen bg-navy-950" />}>
        <StayApp />
      </Suspense>
    );
  }
  return (
    <>
      {/* The chart of Charleston Harbor behind every guest page, beside the
          routes rather than in them so it is drawn once and stays put from
          page to page (HarborChart.jsx). */}
      <HarborChart />
      <GuestRoutes />
    </>
  );
}

function GuestRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Today />} />
      <Route path="/yesterday" element={<Yesterday />} />
      <Route path="/archive/:date" element={<Archive />} />
      <Route path="/about" element={<About />} />
      <Route path="/ai" element={<Ai />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/guides" element={<Guides />} />
      <Route path="/guides/:slug" element={<Guide />} />
      <Route path="/admin" element={<Admin />} />
      <Route
        path="/admin/stay/:slug/revenue"
        element={
          <Suspense fallback={<p className="px-4 pt-16 text-navy-500">Loading…</p>}>
            <RevenueAdmin />
          </Suspense>
        }
      />
      {/* Host-neutral market index. Must precede /stay/:slug so a bare /stay is
          the list, not a property lookup for the literal slug "". */}
      <Route path="/stay" element={<StayIndex />} />
      <Route path="/stay/:slug" element={<Stay />} />
      <Route path="/stay/:slug/guide" element={<StayGuide />} />
      <Route path="/stay/:slug/confirmed" element={<StayConfirmed />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

// Unknown path. The shared shell is the page; this only supplies the copy.
function NotFound() {
  return (
    <NotFoundPage
      title="Nothing here."
      seoTitle="Not found · Charleston.Vacations"
    >
      <Link to="/" className="text-navy-700 underline">Back to today's brief</Link>
    </NotFoundPage>
  );
}
